module.exports = __webpack_public_path__ + "getting-things-done.2Ms4ulwD.svg";